/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBillingInvoicePdfResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type BillingInvoicePdfResponse, type ErrorResponse, type InternalErrorResponse } from '../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/subscriptions/invoices/{invoiceId}/pdf
 */
export interface PdfRequestBuilder extends BaseRequestBuilder<PdfRequestBuilder> {
    /**
     * Returns a short-lived download link for one of this organization's billing invoices.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<BillingInvoicePdfResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<BillingInvoicePdfResponse | undefined>;
    /**
     * Returns a short-lived download link for one of this organization's billing invoices.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PdfRequestBuilderUriTemplate = "{+baseurl}/api/organizations/subscriptions/invoices/{invoiceId}/pdf";
/**
 * Metadata for all the requests in the request builder.
 */
export const PdfRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: PdfRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createBillingInvoicePdfResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
